import React from 'react';
import { Download, Star, Zap } from 'lucide-react';

const AppCard = ({ title, description, category, tags, color }) => (
    <div className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl overflow-hidden">
        <div className={`absolute top-0 right-0 w-32 h-32 bg-${color}-500/10 rounded-full blur-2xl -mr-16 -mt-16 group-hover:bg-${color}-500/20 transition-all duration-500`}></div>

        <div className="relative z-10">
            <div className="flex justify-between items-start mb-4">
                <div className={`p-3 rounded-lg bg-gradient-to-br from-${color}-500/20 to-transparent border border-${color}-500/20`}>
                    {category === 'Tool' ? <Zap className={`w-6 h-6 text-${color}-400`} /> : <Star className={`w-6 h-6 text-${color}-400`} />}
                </div>
                <span className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-white/10 text-gray-300 border border-white/5">
                    {category}
                </span>
            </div>

            <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed min-h-[60px]">
                {description}
            </p>

            <div className="flex flex-wrap gap-2 mb-6">
                {tags.map((tag, i) => (
                    <span key={i} className="text-xs text-gray-500 bg-black/20 px-2 py-1 rounded">
                        {tag}
                    </span>
                ))}
            </div>

            <button className="w-full py-3 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-white text-sm font-medium transition-all flex items-center justify-center group-hover:border-white/20">
                Coming Soon
            </button>
        </div>
    </div>
);

const AppShowcase = () => {
    const tools = [
        {
            title: "Remy",
            description: "Handle your dead lines. Stop missing them or leave all the task to last minute.",
            category: "Tool",
            tags: ["Time Management", "Utility", "Productivity"],
            color: "blue" // Tailwind color name
        },
        {
            title: "SecureVault",
            description: "Keep your photos and files safe with military-grade encryption and biometric protection.",
            category: "Tool",
            tags: ["Security", "Privacy", "Encryption"],
            color: "emerald"
        },
        {
            title: "QuickScanner",
            description: "Transform your device into a powerful document scanner with OCR and cloud sync.",
            category: "Tool",
            tags: ["Productivity", "Office", "PDF"],
            color: "indigo"
        }
    ];

    const games = [
        {
            title: "Neon Racer",
            description: "High-speed endless runner set in a cyberpunk universe with pumping synthwave soundtrack.",
            category: "Game",
            tags: ["Action", "Arcade", "Offline"],
            color: "pink"
        },
        {
            title: "Cosmic Puzzle",
            description: "Relaxing brain teasers that take you on a journey through the stars.",
            category: "Game",
            tags: ["Puzzle", "Relaxing", "Casual"],
            color: "purple"
        },
        {
            title: "Pixel Quest",
            description: "A retro-inspired RPG adventure with classic mechanics and modern depth.",
            category: "Game",
            tags: ["RPG", "Adventure", "Pixel Art"],
            color: "orange"
        }
    ];

    return (
        <div className="py-24 bg-remy-dark relative">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Tools Section */}
                <div id="apps" className="mb-32 scroll-mt-24">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">Powerful Tools</h2>
                        <p className="text-gray-400 max-w-2xl mx-auto">
                            Utilities designed to make your daily digital life smoother, faster, and more secure.
                        </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {tools.map((app, index) => (
                            <AppCard key={index} {...app} color="indigo" /> // Using indigo as default to avoid invalid tailwind classes if dynamic interpolation fails without safelist
                        ))}
                    </div>
                </div>

                {/* Games Section */}
                <div id="games" className="scroll-mt-24">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">Immersive Games</h2>
                        <p className="text-gray-400 max-w-2xl mx-auto">
                            Experiences crafted for fun, challenge, and pure entertainment.
                        </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {games.map((game, index) => (
                            <AppCard key={index} {...game} color="purple" />
                        ))}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default AppShowcase;
